import { apiService } from "../../../utils/api/api.service";
import { requestWithErrorHandling } from "../../../utils/error/handle.error";
import { ContactSupportPayload } from "../interfaces/contactSupport.interface";

class ContactSupportService {
  private static instance: ContactSupportService;

  static getInstance(): ContactSupportService {
    if (!ContactSupportService.instance) {
      ContactSupportService.instance = new ContactSupportService();
    }
    return ContactSupportService.instance;
  }

  submitMessage = (payload: ContactSupportPayload) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post<{ success: boolean; message?: string }>(
        "/contact-support",
        payload
      );
    });
  };
}

export const contactSupportService = ContactSupportService.getInstance();
